import { render, staticRenderFns } from "./ProjektAuswahl.vue?vue&type=template&id=bbf1a992&"
import script from "./ProjektAuswahl.vue?vue&type=script&lang=js&"
export * from "./ProjektAuswahl.vue?vue&type=script&lang=js&"
import style0 from "./ProjektAuswahl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports